// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3cIWw","fileDisabled":"File_fileDisabled__36YrH"};